export enum SingularEvent {
  OpenTabHasExpiringTodayTask = 'Open tab has expiring today task',
  Made2OutboundsIn1Hour = 'Made 2 outbounds in 1 hour',
}
